module.exports = __webpack_public_path__ + "img/lea-42.54129501.png";